function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.465 283.465"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Solar_power_copy_2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M141.732 106.299c13.613 0 25.048 3.21 32.2 9.04 6.944 5.66 10.319 14.293 10.319 26.393s-3.375 20.733-10.319 26.393c-7.152 5.83-18.588 9.04-32.2 9.04-13.613 0-25.049-3.21-32.2-9.04-6.944-5.66-10.319-14.293-10.319-26.393s3.375-20.733 10.319-26.393c7.152-5.829 18.587-9.04 32.2-9.04m0-28.346c-39.138 0-70.866 19.845-70.866 63.78s31.728 63.78 70.866 63.78 70.866-19.845 70.866-63.78-31.728-63.78-70.866-63.78z"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M141.732 63.78V0M77.953 77.953L42.52 42.52M56.693 141.732H0M77.953 205.431L42.52 240.945M141.732 219.685v63.78M205.512 205.512l35.433 35.433M226.772 141.732h56.693M205.512 77.953l35.433-35.433"
}))));